/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { EmployeeCostsByJobRoleAndLocation } from './EmployeeCostsByJobRoleAndLocation';
import {
    EmployeeCostsByJobRoleAndLocationFromJSON,
    EmployeeCostsByJobRoleAndLocationFromJSONTyped,
    EmployeeCostsByJobRoleAndLocationToJSON,
    EmployeeCostsByJobRoleAndLocationToJSONTyped,
} from './EmployeeCostsByJobRoleAndLocation';

/**
 * 
 * @export
 * @interface ListEmployeeCostsByJobRoleAndLocationResponse
 */
export interface ListEmployeeCostsByJobRoleAndLocationResponse {
    /**
     * 
     * @type {Array<EmployeeCostsByJobRoleAndLocation>}
     * @memberof ListEmployeeCostsByJobRoleAndLocationResponse
     */
    data: Array<EmployeeCostsByJobRoleAndLocation>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEmployeeCostsByJobRoleAndLocationResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListEmployeeCostsByJobRoleAndLocationResponse interface.
 */
export function instanceOfListEmployeeCostsByJobRoleAndLocationResponse(value: object): value is ListEmployeeCostsByJobRoleAndLocationResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEmployeeCostsByJobRoleAndLocationResponseFromJSON(json: any): ListEmployeeCostsByJobRoleAndLocationResponse {
    return ListEmployeeCostsByJobRoleAndLocationResponseFromJSONTyped(json, false);
}

export function ListEmployeeCostsByJobRoleAndLocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmployeeCostsByJobRoleAndLocationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeeCostsByJobRoleAndLocationFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEmployeeCostsByJobRoleAndLocationResponseToJSON(json: any): ListEmployeeCostsByJobRoleAndLocationResponse {
      return ListEmployeeCostsByJobRoleAndLocationResponseToJSONTyped(json, false);
  }

  export function ListEmployeeCostsByJobRoleAndLocationResponseToJSONTyped(value?: ListEmployeeCostsByJobRoleAndLocationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeeCostsByJobRoleAndLocationToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

